import { useRouter, defineNuxtPlugin, useCurrentLanguage } from "#imports";
import {
  routeNamesWithLanguageParam,
  routeNamesWithoutMapping,
  pageLanguageLinks
} from "#nuxt-language-negotiation/routes";
import {
  defaultLangcode,
  langcodeToPrefix
} from "#nuxt-language-negotiation/config";
export default defineNuxtPlugin({
  name: "nuxt-language-negotiation:router",
  dependsOn: ["nuxt:router"],
  setup() {
    const router = useRouter();
    const currentLanguage = useCurrentLanguage();
    function translateLocation(v) {
      if (typeof v === "object") {
        if ("name" in v && v.name) {
          let name = v.name?.toString() || "";
          const params = { ...v.params || {} };
          if (routeNamesWithLanguageParam.includes(name) && !params.langPrefix) {
            params.langPrefix = langcodeToPrefix[currentLanguage.value];
          }
          if (name && !name.includes("___") && !routeNamesWithoutMapping.includes(name)) {
            const links = pageLanguageLinks[name];
            if (links) {
              const hasLinkInLanguage = links[currentLanguage.value];
              if (hasLinkInLanguage) {
                name = name + "___" + currentLanguage.value;
              } else {
                name = name + "___" + defaultLangcode;
              }
            }
          }
          return {
            ...v,
            name,
            params
          };
        }
      }
      return v;
    }
    const originalResolve = router.resolve;
    router.resolve = (to, currentLocation) => {
      return originalResolve(translateLocation(to), currentLocation);
    };
    const originalPush = router.push;
    router.push = function(v) {
      return originalPush(translateLocation(v));
    };
    const originalReplace = router.replace;
    router.replace = function(v) {
      return originalReplace(translateLocation(v));
    };
  }
});
